<h2 mat-dialog-title class="dialog-header">
  {{'kiosksync.title'|traduccion}}
  <button mat-icon-button class="close-btn" aria-label="Close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content kiosk-sync-dialog-content mat-typography">
  <section class="kiosk-sync-hero">
    <div>
      <div class="kiosk-sync-kicker">{{'kiosksync.details.kicker'|traduccion}}</div>
      <h3>{{ valueOrDash(kioskSync?.aggregateType) }} · {{ valueOrDash(kioskSync?.aggregateId) }}</h3>
      <p>{{'kiosksync.details.tenantId'|traduccion}} {{ valueOrDash(kioskSync?.tenantId) }} · {{'kiosksync.details.locationId'|traduccion}} {{ valueOrDash(kioskSync?.locationId) }}</p>
    </div>
    <div class="kiosk-sync-hero-chips">
      <span [class]="statusClass(kioskSync?.status)">{{ formatEnumLabel(kioskSync?.status) }}</span>
      <span class="ks-chip ks-chip--neutral">{{'kiosksync.details.pendingChanges'|traduccion}}: {{ pendingChangesLabel(kioskSync?.hasPendingLocalChanges) }}</span>
    </div>
  </section>

  <div class="kiosk-sync-grid">
    <mat-card class="kiosk-sync-card">
      <h4>{{'kiosksync.details.summary.title'|traduccion}}</h4>
      <div class="kiosk-sync-fields">
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.summary.id'|traduccion}}</span>
          <span>{{ valueOrDash(kioskSync?.id) }}</span>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.summary.domainVersion'|traduccion}}</span>
          <span>{{ valueOrDash(kioskSync?.domainVersion) }}</span>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.summary.lastAckVersion'|traduccion}}</span>
          <span>{{ valueOrDash(kioskSync?.lastAckVersion) }}</span>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.summary.expectedVersion'|traduccion}}</span>
          <span>{{ valueOrDash(kioskSync?.expectedVersion) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="kiosk-sync-card">
      <h4>{{'kiosksync.details.dates.title'|traduccion}}</h4>
      <div class="kiosk-sync-fields">
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.dates.lastAckAt'|traduccion}}</span>
          <span>{{ formatDateTime(kioskSync?.lastAckAt) }}</span>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.dates.lastReconcileAt'|traduccion}}</span>
          <span>{{ formatDateTime(kioskSync?.lastReconcileAt) }}</span>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.dates.lastIssueAt'|traduccion}}</span>
          <span>{{ formatDateTime(kioskSync?.lastIssueAt) }}</span>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.dates.updatedAt'|traduccion}}</span>
          <span>{{ formatDateTime(kioskSync?.updatedAt) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="kiosk-sync-card kiosk-sync-card--wide">
      <h4>{{'kiosksync.details.checksums.title'|traduccion}}</h4>
      <div class="kiosk-sync-fields">
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.checksums.baseState'|traduccion}}</span>
          <code>{{ valueOrDash(kioskSync?.checksumBaseState) }}</code>
        </div>
        <div class="kiosk-sync-field">
          <span class="kiosk-sync-field-label">{{'kiosksync.details.checksums.fullState'|traduccion}}</span>
          <code>{{ valueOrDash(kioskSync?.checksumFullState) }}</code>
        </div>
      </div>
    </mat-card>

    <mat-card class="kiosk-sync-card kiosk-sync-card--wide">
      <h4>{{'kiosksync.details.pendingLocalEvents'|traduccion}}</h4>
      <pre class="kiosk-sync-pre">{{ formatJson(kioskSync?.pendingLocalEvents) }}</pre>
    </mat-card>
  </div>
</mat-dialog-content>
